export enum ServiceOrderStatus {
  NEW = 'Новый',
  DONE = 'Выполнен',
  CANCELED = 'Отменен',
  ACCEPTED = 'Подтвержден',
}